import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@shared/lib/cn';

export const TooltipProvider = TooltipPrimitive.Provider;

export function Tooltip({ children, content, side = 'top' }: { children: React.ReactNode; content: React.ReactNode; side?: 'top' | 'right' | 'bottom' | 'left' }) {
  return (
    <TooltipPrimitive.Root delayDuration={250}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className={cn(
            'z-50 rounded-md border border-line-subtle/15 bg-bg-3 px-2.5 py-1.5 text-xs text-fg-hi shadow-card',
            'data-[state=delayed-open]:animate-fade-in'
          )}
        >
          {content}
          <TooltipPrimitive.Arrow className="fill-bg-3" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
